module.exports = __webpack_public_path__ + "static/media/New Zealand - NZ.18439820.png";